module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "yandex-map-opener"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.open = !_vm.open
      }
    }
  }, [_vm._v("Уточнить на карте")])])])]), _vm._v(" "), _c('div', {
    staticClass: "yandex-map-container",
    class: {
      'yandex-map-container--open': _vm.open
    }
  }, [_c('tc-input', {
    staticClass: "mt-1",
    attrs: {
      "label-text": 'Координаты'
    },
    model: {
      value: (_vm.coordsString),
      callback: function($$v) {
        _vm.coordsString = $$v
      },
      expression: "coordsString"
    }
  }), _vm._v(" "), _c('yandex-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "coords": _vm.mapCoord,
      "placemarks": _vm.placemarks,
      "zoom": "14",
      "map-type": "map"
    },
    on: {
      "map-was-initialized": _vm.initHandler
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-e17cc646"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcMap.vue
// module id = 1074
// module chunks = 1